import { createSlice } from "@reduxjs/toolkit";
import { E_GenereOmbrellone, E_TipoOmbrellone, E_MisureOmbrelloni, E_MainLato, E_ColoriTessuto, E_ConfOmbrelloniContrapposti, E_KitLedOmbrelloni, } from "../../components/Utils/enumerations";

export const uiOmbrelloniSlice = createSlice({
    name: "UI_ombrelloni",
    initialState: {
        isVisible: false,
        selezioneMisuraAutomatica: true,
        genereOmbrellone: E_GenereOmbrellone.Braccio.toString(),
        tipoOmbrellone: E_TipoOmbrellone.Scegli.toString(),
        mantovana: false,
        misureOmbrellone: E_MisureOmbrelloni.Scegli.toString(),
        misuraOmbrelloneAutomatica: E_MisureOmbrelloni.Automatica.toString(),
        latoOmbrelloni: E_MainLato.Scegli.toString(),            
        coloreTessutoOmbrelloni: E_ColoriTessuto.T15.toString(),   
        grondaie: false,
        numeroGrondaie: 0,
        nastratura: false,
        velcro: false,
        dataOmbrelloni: [],   
        ombrelloniContrapposti: false, 
        confOmbrelloniContrapposti: E_ConfOmbrelloniContrapposti.InLinea.toString(),
        hasLed: false,
        tipoKitLed: E_KitLedOmbrelloni.kit0_5m.toString(),
        hasDimmerTel: false,
    },
    reducers: {
        setOmbrelloniMenuVisible: (state, action) => {            
            state.isVisible = action.payload;    
        },  
        handleAutomaticMeasureSelection: (state, action) => {
            state.selezioneMisuraAutomatica = action.payload;
        },
        handleGenereOmbrellone: (state, action) => {
            state.genereOmbrellone = action.payload;
        },       
        handleOmbrelloniTipo: (state, action) => {
            state.tipoOmbrellone = action.payload;
        },
        handleOmbrelloniDimensioni: (state, action) => {
            state.misureOmbrellone = action.payload;         
        },
        handleOmbrelloniDimensioneAuto: (state, action) => {
            state.misuraOmbrelloneAutomatica = action.payload;         
        },
        handleOmbrelloniLato: (state,action) => {
            state.latoOmbrelloni = action.payload;
        },       
        handleColoreTessutoOmbrelloni: (state, action) => {
            state.coloreTessutoOmbrelloni = action.payload;
        }, 
        handleOmbrelloniMantovana: (state, action) => {
            state.mantovana = action.payload;
        },
        handleOmbrelloniGrondaie: (state,action) => {
            if (action.payload) {
                state.velcro = true;              
            } else {
                state.velcro = false;              
            }
            state.grondaie = action.payload;
        },
        setNumeroGrondaie: (state, action) => {
            state.numeroGrondaie = action.payload;
        },
        handleOmbrelloniNastratura: (state, action) => {
            state.nastratura = action.payload;
        },
        handleOmbrelloniVelcro: (state, action) => {
            state.velcro = action.payload;
        },
        handleDataOmbrelloni: (state, action) => {
            state.dataOmbrelloni = action.payload;
        },
        setOmbrelloniContrapposti: (state, action) => {
            state.ombrelloniContrapposti = action.payload;
        },
        handleConfigurazioneContrapposti: (state, action) => {
            state.confOmbrelloniContrapposti = action.payload;
        },
        setHasLed: (state, action) => {
            state.hasLed = action.payload;
        },
        handleKitLed: (state, action) => {    
            state.tipoKitLed = action.payload;
        },
        setHasDimmerTel: (state, action) => {
            state.hasDimmerTel = action.payload;
        }   
    }
});

export const { setOmbrelloniMenuVisible,
               handleAutomaticMeasureSelection,      
               handleColoreTessutoOmbrelloni,
               handleGenereOmbrellone,  
               handleOmbrelloniTipo,  
               handleOmbrelloniDimensioni,
               handleOmbrelloniDimensioneAuto,
               handleOmbrelloniLato,    
               handleOmbrelloniMantovana,  
               handleOmbrelloniGrondaie,
               setNumeroGrondaie,
               handleOmbrelloniNastratura,
               handleOmbrelloniVelcro,
               handleDataOmbrelloni,
               setOmbrelloniContrapposti,
               handleConfigurazioneContrapposti,
               setHasLed,
               handleKitLed,
               setHasDimmerTel
            } = uiOmbrelloniSlice.actions;

export default uiOmbrelloniSlice.reducer;